import { render, staticRenderFns } from "./PlayerTitle.vue?vue&type=template&id=67ed6d78&scoped=true&"
var script = {}
import style0 from "./PlayerTitle.vue?vue&type=style&index=0&id=67ed6d78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed6d78",
  null
  
)

export default component.exports